import React from "react";
import Input from "../../UI/Input/Input";
import Button from "../../UI/Button/Button";
import ContentForm from "../../UI/ContentForm/ContentForm";
import DatePicker from "../../UI/DatePicker/DatePicker";
import { updateObject, checkValidity } from "../../../shared/utility";
import "./TariffForm.css";
import Fade from "react-reveal/Fade";
import FetchData from "../../../shared/fetchData";

const TariffForm = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [changeForm, setChangeForm] = React.useState(false);
  const [invalidDate, setInvalidDate] = React.useState(false);
  const [id, setId] = React.useState("");
  const [fromDate, setFromDate] = React.useState("");
  const [toDate, setToDate] = React.useState("");
  const [tariff, setTariff] = React.useState({
    description: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "شرح تعرفه",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    cancelPenaltyPercent: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "درصد کسر مبلغ",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    firstMilePrice: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "هزینه جمع آوری",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "0",
    },
    lastMilePrice: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "هزینه تخلیه",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "0",
    },
    returnPassValue: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "هزینه رمز مرجوعی",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "0",
    },
  });

  React.useEffect(() => {
    if (props.edit == true) {
      const lckrTp = tariff;
      lckrTp.description.value = props.tariff.description;
      lckrTp.cancelPenaltyPercent.value = props.tariff.cancelPenaltyPercent;
      lckrTp.firstMilePrice.value = props.tariff.firstMilePrice?.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );
      lckrTp.lastMilePrice.value = props.tariff.lastMilePrice?.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );
      lckrTp.returnPassValue.value = props.tariff.returnPassValue?.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );
      setTariff(lckrTp);
      setFromDate(props.tariff.fromDate);
      setToDate(props.tariff.toDate);
      setEdit(true);
      setId(props.tariff.id);
    }
  }, []);

  const inputChangedHandler = (event, controlName) => {
    let val =
      controlName == "firstMilePrice" ||
      controlName == "lastMilePrice" ||
      controlName == "returnPassValue"
        ? event.target.value.toString().replace(/[^0-9]/g, "")
        : event.target.value;
    let value =
      controlName == "firstMilePrice" ||
      controlName == "lastMilePrice" ||
      controlName == "returnPassValue"
        ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : val;
    const updatedControls = updateObject(tariff, {
      [controlName]: updateObject(tariff[controlName], {
        value: value,
        valid: checkValidity(
          event.target.value,
          tariff[controlName].validation
        ),
      }),
    });
    setTariff(updatedControls);
  };

  const changeFromDate = (unix, formatted) => {
    setFromDate(formatted);
  };
  const changeToDate = (unix, formatted) => {
    setToDate(formatted);
  };
  const tariffSubmit = (event) => {
    let valid = true;
    const zn = tariff;
    for (let key in zn) {
      if (zn[key].value == "") {
        zn[key].valid = false;
        valid = false;
      }
    }
    if (fromDate == null || toDate == null || fromDate == "" || toDate == "") {
      setInvalidDate(true);
    }
    if (!valid) {
      setTariff(zn);
      if (changeForm) {
        setChangeForm(false);
      } else {
        setChangeForm(true);
      }
    } else {
      if (!edit) {
        setLoading(true);
        const lckrTp = tariff;
        var raw = JSON.stringify({
          tariff: {
            description: lckrTp.description.value,
            cancelPenaltyPercent: lckrTp.cancelPenaltyPercent.value,
            firstMilePrice: lckrTp.firstMilePrice.value
              ?.toString()
              .replace(/[^0-9]/g, ""),
            lastMilePrice: lckrTp.lastMilePrice.value
              ?.toString()
              .replace(/[^0-9]/g, ""),
            returnPassValue: lckrTp.returnPassValue.value
              ?.toString()
              .replace(/[^0-9]/g, ""),
            fromDate: fromDate,
            toDate: toDate,
          },
          version: "mtpx001",
        });

        var url = "management/api/v1/tariffs/insertTariff";
        FetchData(raw, url)
          .then((response) => response.json())
          .then((result) => {
            setLoading(false);
            if (result.status == 0) {
              props.toggleNewLockerForm(event, false);
            }
          })
          .catch((error) => setLoading(false));
      } else {
        setLoading(true);
        const lckrTp = tariff;
        var raw = JSON.stringify({
          tariff: {
            id: id,
            description: lckrTp.description.value,
            cancelPenaltyPercent: lckrTp.cancelPenaltyPercent.value,
            firstMilePrice: lckrTp.firstMilePrice.value,
            lastMilePrice: lckrTp.lastMilePrice.value,
            returnPassValue: lckrTp.returnPassValue.value,
            fromDate: fromDate,
            toDate: toDate,
          },
          version: "mtpx001",
        });

        var url = "management/api/v1/tariffs/updateTariff";
        FetchData(raw, url)
          .then((response) => response.json())
          .then((result) => {
            setLoading(false);
            if (result.status == 0) {
              props.toggleNewLockerForm(event, false);
            }
          })
          .catch((error) => setLoading(false));
      }
    }
  };

  const formElementsArray = [];
  for (let key in tariff) {
    formElementsArray.push({
      id: key,
      config: tariff[key],
    });
  }

  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        search={true}
        col="6 mt-2"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });
  return (
    <Fade duration={200} left cascade>
      <div>
        <div className="row justify-content-center">
          <div className="tariff-cntnr">
            <ContentForm headetText="تعرفه">
              <div className="tariff-frm">
                {form}
                <DatePicker
                  className={
                    invalidDate && (fromDate == null || fromDate == "")
                      ? "invalid-date"
                      : ""
                  }
                  change={changeFromDate}
                  value={fromDate}
                  placeHolder="از تاریخ"
                  col="6"
                />
                <DatePicker
                  className={
                    invalidDate && (toDate == null || toDate == "")
                      ? "invalid-date"
                      : ""
                  }
                  change={changeToDate}
                  value={toDate}
                  placeHolder="تا تاریخ"
                  col="6"
                />
              </div>
              <div className="col-12">
                <div className="row justify-content-center w-100 mt-3">
                  <div className="col-6 text-center">
                    <Button
                      btnType="General"
                      clicked={(event) =>
                        props.toggleNewLockerForm(event, false)
                      }
                    >
                      برگشت
                    </Button>
                  </div>
                  <div className="col-6 text-center">
                    <Button btnType="Success" clicked={tariffSubmit}>
                      ثبت
                    </Button>
                  </div>
                </div>
              </div>
            </ContentForm>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default TariffForm;
